/**
 * MQTT接続の判定ロジック（Shop.vue/Remote.vue/Takeout.vue createConnection() 共通、cmd_986）。
 *
 * mqtt ライブラリや Vue コンポーネントの状態に依存しない純粋関数として切り出すことで、
 * 「新規 connect 呼び出しに到達するか」をユニットテストで直接検証できるようにする。
 */

/**
 * host が接続可能な形式か判定する（空でなく ws:// または wss:// で始まる）。
 */
export function isValidHost(host: string | undefined | null): boolean {
  return !!host && /^wss?:\/\//.test(host);
}

/**
 * 既存 client が接続済み(connected)または接続処理中(connecting)であれば true を返す。
 * true の場合、新規 connect を発行せずスキップすべきことを意味する。
 */
export function shouldSkipConnect(
  client: { connected: boolean } | null | undefined,
  connecting: boolean
): boolean {
  return !!client && (client.connected || connecting);
}
